import React, { useRef } from 'react';
import { useParallax } from './useParallax';
import ArthLogo from '../../assets/img/arth_logo.svg';

export default function VisualPanel({ isMounted }) {
  const visualRef = useRef(null);
  useParallax(visualRef);

  const orbitParticles = [
    { angle: 0, color: '#311b92', size: 8, speed: 11, direction: 'reverse', radius: 170 },
    { angle: 72, color: '#311b92', size: 6, speed: 7, direction: 'normal', radius: 190 },
    { angle: 144, color: '#311b92', size: 7, speed: 7, direction: 'reverse', radius: 85 },
    { angle: 216, color: '#311b92', size: 5, speed: 15, direction: 'normal', radius: 95 },
    { angle: 288, color: '#311b92', size: 10, speed: 20, direction: 'reverse', radius: 210 },
  ];

  // Conditionally apply 'is-mounted' class for animations
  const panelClasses = `visual-panel ${isMounted ? 'is-mounted' : ''}`;
  const containerClasses = `visual-container ${isMounted ? 'is-mounted' : ''}`;

  return (
    <div className={panelClasses}>
      <div className={containerClasses}>
        <div ref={visualRef} className="parallax-layer">
          {/* Glow background */}
          <div className="glow-background">
            <div className="glow"></div>
          </div>

          {/* Logo */}
          <div className="logo-container">
            <img src={ArthLogo} alt="Logo" className="logo-image" />
          </div>

          {/* Spinning Orbits */}
          <div className="spinning-orbits">
            <div className="orbit-path slow">
              <svg width="300" height="300" viewBox="0 0 300 300">
                <circle cx="150" cy="150" r="150" fill="none" stroke="#311b92" strokeWidth="2" strokeDasharray="8 6" />
              </svg>
            </div>
            <div className="orbit-path reverse">
              <svg width="260" height="260" viewBox="0 0 260 260">
                <circle cx="130" cy="130" r="110" fill="none" stroke="#311b92" strokeWidth="1.5" strokeDasharray="4 4" />
              </svg>
            </div>
          </div>

          {/* Orbiting Particles */}
          {orbitParticles.map((p, i) => (
            <div
              key={i}
              className="particle-orbit-anchor"
              style={{
                transform: `rotate(${p.angle}deg)`,
              }}
            >
              <div
                className={`particle-animator ${p.direction === 'reverse' ? 'direction-reverse' : ''}`}
                style={{
                  animationDuration: `${p.speed}s`,
                  animationDelay: `${i * 0}s`,
                  '--orbit-radius': `${p.radius}px`,
                }}
              >
                <div
                  className="particle"
                  style={{
                    width: `${p.size}px`,
                    height: `${p.size}px`,
                    backgroundColor: p.color,
                    boxShadow: `0 0 8px 2px ${p.color}88`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="text-content">
        <h1 className="title">
          Helping Small<br />Business Succeed
        </h1>
        <p className="copyright">&copy; {new Date().getFullYear()} ARTH</p>
      </div>
    </div>
  );
}